import { Flex, UnstyledButton } from '@mantine/core'

import type { BudgetHeaderProps } from '@/modules/budget/components/BudgetHeader/BudgetHeader.types'

import { MonthPicker } from '@/components/MonthPicker/MonthPicker'
import { Text } from '@/components/Text/Text'

import { TransactionType } from '@/constants/transactions.constants'

import classes from './BudgetHeader.module.css'

export function BudgetHeader({
  now,
  onMonthChange,
  onTransactionTypeChange,
  selectedType,
}: BudgetHeaderProps) {
  return (
    <Flex className={classes.header}>
      <Flex className={classes.tabs}>
        {Object.values(TransactionType).map(type => (
          <UnstyledButton
            key={type}
            className={classes.button}
            data-selected={selectedType === type}
            onClick={() => onTransactionTypeChange(type)}
          >
            <Text variant="body_1_semibold_green">{type.toUpperCase()}</Text>
          </UnstyledButton>
        ))}
      </Flex>
      <MonthPicker month={now} onChange={onMonthChange} />
    </Flex>
  )
}
